import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { ViewportScroller } from '@angular/common';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-find-a-branch',
  templateUrl: './find-a-branch.component.html',
  styleUrls: ['./find-a-branch.component.css']
})
export class FindABranchComponent implements OnInit {


  branchLocator:any;
  searchWord:any = "";
  visible:boolean = false;
  isAuto:boolean = false;
  paddingSetting:boolean=false;

constructor(
  private spinner: NgxSpinnerService,
  private route: Router,
  private apiService: ApiService,
  private titleService: Title,
) { }

  ngOnInit(): void {
    this.titleService.setTitle("Proof Of Delivery| Line Clear Express")
  }

  goToPortal(){
      window.open('https://www.lineclearexpressonline.com/#/auth/login');
  }

  pitstopLocator(){

    this.visible = true;
    this.isAuto = true;

    if(this.searchWord != ""){
        this.apiService.getPitstopLocator(this.searchWord).subscribe((res: any) => {
    
          this.paddingSetting=true;
            this.branchLocator = res
          console.log(res)
            if(res.length > 0){

            }else{
                Swal.fire("We are sorry.", " The location cannot be found.", "error")
                this.paddingSetting=false;
            }
    
        }, error => {
            Swal.fire("Backend Error!", "Error : <small style='color: red; font-style: italic;'>" + error.error.message + "</small>", "error")
        }) 
    }else{
        Swal.fire('Missing postcode?', 'Invalid request, postcode is required', 'info')
    }

    // reset searchWord  
    this.searchWord = ""

    setTimeout(() => {;
        this.visible = false
    }, 1500);
    
  }

  
 
}